// 차량 제원 리스트
export const vehicleDimension = () => {
  return [
    {
      ton: 0.3,
      width: '1,100',
      length: '1,600',
      height: '1,100',
      maxWeight: 0.6,
      maxPt: 0
    }, //다마스
    {
      ton: 0.5,
      width: '1,400',
      length: '2,200',
      height: 0,
      maxWeight: 0.6,
      maxPt: 2
    }, //라보
    {
      ton: 1,
      width: '1,630',
      length: '2,860',
      height: '1,700',
      maxWeight: 1.2,
      maxPt: 2
    }, //초장축 슈퍼캡
    {
      ton: 1.4,
      width: '1,700',
      length: '3,110',
      height: '1,800',
      maxWeight: 1.2,
      maxPt: 2
    }, //기본
    {
      ton: 2.5,
      width: '1,960',
      length: '4,340',
      height: '2,200',
      maxWeight: 3,
      maxPt: 3
    }, //2.5 기본
    {
      ton: 3.5,
      width: '2,060',
      length: '4,900',
      height: '2,200',
      maxWeight: 4.5,
      maxPt: 4
    }, //3.5 기본
    {
      ton: 5,
      width: '2,230',
      length: '6,200',
      height: '2,400',
      maxWeight: 6,
      maxPt: 10
    }, // 5 기본
    {
      ton: 8,
      width: '2,340',
      length: '7,300',
      height: '2,500',
      maxWeight: 11,
      maxPt: 12
    }, // 8 기본
    {
      ton: 11,
      width: '2,340',
      length: '9,100',
      height: '2,500',
      maxWeight: 12,
      maxPt: 16
    }, // 11 기본
    {
      ton: 18,
      width: '2,340',
      length: '10,100',
      height: '2,500',
      maxWeight: 21,
      maxPt: 20
    }, // 18 기본
    {
      ton: 25,
      width: '2,340',
      length: '10,100',
      height: '2,500',
      maxWeight: 28,
      maxPt: 20
    }, //25 기본
  ]
}